import {
  BusinessChallengesEnum,
  OrganizationBusinessChallengesResponse,
} from '@platform/client/schemas';
import { businessChallengeFullText } from '../../../util/TextHelpers';

export type ChallengeData = {
  challengeOne?: BusinessChallengesEnum;
  challengeOneContext?: string;
  challengeTwo?: BusinessChallengesEnum;
  challengeTwoContext?: string;
  challengeThree?: BusinessChallengesEnum;
  challengeThreeContext?: string;
};

export type ChallengeFormPageProps = {
  organizationId: number;
  onContinue: () => void;
  onBack: () => void;
  challengeData?: OrganizationBusinessChallengesResponse;
};

export const challengeOptions = Object.keys(BusinessChallengesEnum).map((key) => {
  const textValue = BusinessChallengesEnum[key as keyof typeof BusinessChallengesEnum];
  const text = businessChallengeFullText(key);
  return { text, textValue };
});

// export const challengeOptions = [
//   { text: 'Product Market Fit', textValue: BusinessChallengesEnum['product-market-fit'] },
//   {
//     text: 'Branding And Positioning',
//     textValue: BusinessChallengesEnum['branding-and-positioning'],
//   },
//   {
//     text: 'Marketing',
//     textValue: BusinessChallengesEnum['marketing'],
//   },
//   { text: 'Human Resources', textValue: BusinessChallengesEnum['human-resources'] },
//   { text: 'Sales', textValue: BusinessChallengesEnum['sales'] },
//   {
//     text: 'Reporting and Communicating Impact',
//     textValue: BusinessChallengesEnum['reporting-and-communicating-impact'],
//   },
//   { text: 'Customer Success', textValue: BusinessChallengesEnum['customer-success'] },
//   { text: 'Legal', textValue: BusinessChallengesEnum['legal'] },
//   {
//     text: 'Fundraising Preparation',
//     textValue: BusinessChallengesEnum['fundraising-preparation'],
//   },
//   { text: 'Business Operations', textValue: BusinessChallengesEnum['business-operations'] },
//   { text: 'Accounting and Finance', textValue: BusinessChallengesEnum['accounting-and-finance'] },
// ];
